<template>
  <div class="viewerLogin">
    <br />
    <div class="seasoncast-card container">
    <h3>{{ $t('broadcaster-login') }}</h3>
     <p>
       {{ $t('need-to-create-a-account') }} <a href="https://app.seasoncast.com/createAccount.html">{{ $t('switch-to-create-account') }}</a><br />

      </p>
     <hr />
  
     <br />
     <p>Email:</p>
      <input v-model="email" type="email" class="form-control" aria-label="Text input with checkbox">
      <br />
      <p>Password:</p>
      <input  v-model="password" type="password" class="form-control" aria-label="Text input with checkbox"><br />
      <button  v-on:click="loginToViewer"  type="button"  class="btn btn-primary btn-block">{{ $t('login') }}</button>
      <br />
      <div class="text-center">
    {{ $t('forget-password') }} <router-link to="/recovery/forgot">{{ $t('go-to-password-recovery') }}</router-link><br />
      {{ $t('want-to-access-a-viewer-account') }} <a href="/viewer/login">{{ $t('go-to-viewer-login') }}</a>
      </div>
   </div>
     </div>
</template>

<script>

  import Swal from "sweetalert2"
  import axios from "axios"
  import cookie from "cookie.js"

let API = "https://app.seasoncast.com/"
export default {
        created: async function () {
    console.log("create call")

        },
        data: function () {
    return {
      email: "",
      password: ""
    }
  },
    methods:{
         loginToViewer: async function () {
              let getEventResponse = await axios.post(API+ "v2/broadcaster/login", {
    email: this.email,
    password:  this.password
  }) 

    let responseData = getEventResponse.data
    console.log(responseData)

        if (!responseData.success){
  Swal.fire(
  'Login Error',
  'Reason: '+responseData.message,
  'error'
)
return
         }

let key = responseData.key
let email = responseData.broadcaster.email

    cookie.set("broadcaster-email",email, { path: '/' })
    cookie.set("broadcaster-key",key, { path: '/' })
    cookie.set("broadcaster-token",responseData.token, { path: '/' })
    this.$store.commit("setAuth", {token: responseData.token, broadcaster: responseData.broadcaster})
    this.$store.commit("setBroadcasterChannels",responseData.channels)
    this.$router.push('/broadcaster/customize');
         }
    }
}
    </script>